export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "CEO",
    company: "Mitchell & Co. Ltd",
    text: "MTC Associates completely changed how we handle our finances. Their team is incredibly thorough, proactive, and always available when we need them. Our year-end stress has basically disappeared.",
    initials: "SM",
    type: "business",
  },
  {
    id: 2,
    name: "James Hartwell",
    role: "Founder",
    company: "Hartwell Construction",
    text: "We've been with MTC Associates for over six years now. They saved us a significant amount in taxes last year alone by catching deductions we were missing. I wouldn\'t trust anyone else with our books.",
    initials: "JH",
    type: "business",
  },
  {
    id: 3,
    name: "Priya Nair",
    role: "Freelance Designer",
    company: "Independent",
    text: "As a self-employed creative, taxes were my biggest headache. MTC Associates made the whole process seamless. They\'re patient, explain everything clearly, and genuinely care about their clients.",
    initials: "PN",
    type: "individual",
  },
  {
    id: 4,
    name: "Daniel Okonkwo",
    role: "Operations Director",
    company: "Okonkwo Logistics Group",
    text: "Professional, reliable, and incredibly detail-oriented. MTC Associates handles our multi-entity accounting with precision and always delivers on time. They feel like an extension of our own team.",
    initials: "DO",
    type: "business",
  },
  {
    id: 5,
    name: "Emma Larsson",
    role: "Real Estate Investor",
    company: "Independent",
    text: "I manage several rental properties and MTC Associates keeps everything organized and compliant. Their advice on structuring my investments has genuinely made a financial difference.",
    initials: "EL",
    type: "individual",
  },
  {
    id: 6,
    name: "Thomas Crane",
    role: "Managing Partner",
    company: "Crane & Webb Legal",
    text: "Exceptional service, every single year. They understand the nuances of professional services accounting better than any firm we've worked with. Highly recommend to any professional practice.",
    initials: "TC",
    type: "business",
  },
];